import { Seo } from "@/components/Seo";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Seo
        title="Terms of Use — Shineni India"
        description="Terms of use for the Shineni India website, a B2B denim manufacturing brand of Madneel Ventures Pvt. Ltd."
      />
      <section className="border-b border-border bg-white">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
          <h1 className="font-display text-4xl font-semibold text-indigo">Terms of Use</h1>
          <p className="mt-3 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>
        </div>
      </section>
      <section className="mx-auto max-w-4xl space-y-8 px-4 py-14 text-sm leading-relaxed text-foreground/80 sm:px-6">
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">About this website</h2>
          <p className="mt-2">This website is operated by Madneel Ventures Pvt. Ltd. for its brand Shineni India, Faridabad, Haryana, India. It presents our B2B denim manufacturing services to wholesale, export and private-label buyers.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">B2B only</h2>
          <p className="mt-2">This website does not sell products retail and has no checkout. All products shown are sample styles; images are representative sample imagery and do not depict shipped production.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Quotations</h2>
          <p className="mt-2">Pricing, minimum order quantities, lead times and delivery terms are provided only in written quotations against specific requirements. Nothing on this website constitutes a binding offer, price list or delivery commitment.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Accuracy of information</h2>
          <p className="mt-2">We work to keep website content accurate, but business details such as registrations and certifications are published only after verification and may be updated without notice.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Intellectual property</h2>
          <p className="mt-2">All text and branding on this website belong to Madneel Ventures Pvt. Ltd. and may not be reused without written permission.</p>
        </div>
        <div>
          <h2 className="font-display text-xl font-semibold text-indigo">Governing law</h2>
          <p className="mt-2">Use of this website is governed by the laws of India, with jurisdiction at Faridabad, Haryana.</p>
        </div>
      </section>
    </div>
  );
}
